import { LinearProgress } from '@material-ui/core';
import DataGrid from 'components/DataGrid/DataGrid';
import { toFA } from 'fns/toFA';
import React, { useEffect, useMemo } from 'react';
// import { localText } from '../../../../../langs/fa/data-grid';
import { isMobile } from 'react-device-detect';
import { useMainStore } from 'useStores/useMainStore';
import { toEN } from 'fns';
import { formatNumber } from 'fns';
import { rond } from 'fns';
import UserAvatar from 'components/User/UserAvatar';
import { useHistory } from 'react-router-dom';
import { useOnlineDriversStore } from 'useStores/useOnlineDriversStore';
import axios from 'api/axios';
import { useQuery } from 'react-query';
import { normalizeMobilePhone } from 'fns';
import moment from 'moment-jalaali';
import { useSearchParams } from 'hooks/useSearchParams';
import Total from 'components/Total/Total';

const List = () => {
  const drivers = useOnlineDriversStore((state) => state.drivers);
  const changePage = useOnlineDriversStore((state) => state.changePage);
  const page = useOnlineDriversStore((state) => state.page);
  const setTotalDrivers = useOnlineDriversStore(
    (state) => state.setTotalDrivers
  );
  const limit = useMainStore((state) => state.limit);
  const history = useHistory();
  const [params, setParams] = useSearchParams();
  // const isLoading = useOnlineDriversStore((state) => state.isLoading);

  const handleGetOnlineDrivers = async () => {
    const { data } = await axios.get(
      `/api/v1/admin/reports/listAppDrivers?page=${
        params.get('page') || 1
      }&limit=${limit}`
    );
    setTotalDrivers(data.drivers.totalDocs);
    return data;
  };

  const columns = [
    {
      field: 'row',
      sortable: true,
      headerName: 'ردیف',
      width: 90,
      renderCell: ({ value }) => <div>{toFA(value)}</div>,
    },
    {
      field: 'fullName',
      sortable: true,
      headerName: 'نام و نام خانوادگی',
      flex: 1,
      renderCell: ({ value }) => (
        <div className="d-flex" style={{ gap: 8 }}>
          <UserAvatar user={value} fullName width={30} height={30} justAvatar />
          <div>{`${value?.firstName || ''} ${value?.lastName || ''}`}</div>
        </div>
      ),
    },
    {
      field: 'phoneNumber',
      sortable: false,
      headerName: 'شماره تماس',
      flex: 1,
      renderCell: ({ value }) => <div>{normalizeMobilePhone(value)}</div>,
    },
    {
      field: 'createdAt',
      sortable: true,
      headerName: 'تاریخ ورود',
      flex: 1,
      renderCell: ({ value }) => (
        <div>{moment(value).format('dddd jYYYY/jMM/jDD ')}</div>
      ),
    },
  ];

  const handlePageChange = async (page) => {
    setParams([{ name: 'page', value: page }]);
    changePage(page);
  };

  const { data, isLoading } = useQuery(
    ['onlineDrivers', params.get('page') || 1],
    handleGetOnlineDrivers
  );

  function handleSelectUser(user) {
    const userId = data.drivers.docs.find((item) => item._id === user?.row?.id);
    history.push(`/protected/admin/users/driver/${userId.user._id}`);
  }

  return (
    <div
      style={{
        width: '100%',
        position: 'relative',
        height: isMobile ? 'initial' : 480,
      }}
    >
      {isLoading && <LinearProgress />}
      <DataGrid
        rows={
          data?.drivers?.docs?.map((user, i) => ({
            id: user._id,
            row: (page * 1 - 1) * (limit * 1) + i + 1,
            fullName: user.user,
            phoneNumber: user.user.mobilePhone || user.user.phone,
            createdAt: user.createdAt,
          })) || []
        }
        columns={columns}
        // localeText={localText}
        onPageChange={handlePageChange}
        paginationMode="server"
        pageSize={limit}
        pageNumber={params.get('page') * 1 || 1}
        rowCount={data?.drivers?.totalDocs || 0}
        disableMultipleSelection
        // onCellClick={handleSelectUser}
        density="compact"
        totalPages={data?.drivers?.totalPages}
        defaultPage={params.get('page') || 1}
        footerPagination={true}
        onCellClick={handleSelectUser}
        // onSelectionChange={handleSelectUser}
      />
    </div>
  );
};

export default List;
